import { FormSection, Link, Timeline } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

interface ITcorFollowingStepsProps {
    isPractice?: boolean;
}
export function TcorFollowingSteps({ isPractice }: ITcorFollowingStepsProps) {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    if (isPractice) {
        return (
            <FormSection title="Vervolgstappen rust ECG onderzoek (op praktijk)">
                <Timeline>
                    <Timeline.Item>Jij of de POH maakt een rust ECG op de praktijk</Timeline.Item>
                    <Timeline.Item>
                        Je laadt de onderzoeksdata in het Ksyos platform en beoordeelt het onderzoek zelf of vraagt een
                        consult aan bij een cardioloog
                    </Timeline.Item>
                    <Timeline.Item>
                        Gemiddeld binnen 5 uur, maar uiterlijk binnen drie werkdagen na uitlezen holter ontvang je de
                        uitslag in het Ksyos platform en via Edifact in je HIS als je je{' '}
                        <Link
                            openInNewTab={true}
                            to={`/employments/${selectedEmploymentId}/personalSettings`}
                            variant="link"
                        >
                            zorgmailnummer hebt doorgegeven
                        </Link>
                    </Timeline.Item>
                    <Timeline.Item>
                        Optioneel: Je stuurt het onderzoek door naar een Ksyos cardioloog voor advies over het
                        vervolgbeleid (via een consult)
                    </Timeline.Item>
                </Timeline>
            </FormSection>
        );
    }

    return (
        <FormSection title="Vervolgstappen rust ECG onderzoek (extern)">
            <Timeline>
                <Timeline.Item>
                    Het MDC maakt een afspraak met de patiënt voor het uitvoeren van de rust ECG
                </Timeline.Item>
                <Timeline.Item>
                    Het MDC maakt een rust ECG bij de patiënt, waarna de onderzoeksdata in het Ksyos platform wordt
                    geladen
                </Timeline.Item>
                <Timeline.Item>De Ksyos cardioloog beoordeelt het onderzoek</Timeline.Item>
                <Timeline.Item>
                    Binnen 2 werkdagen na het onderzoek ontvang je de uitslag in het Ksyos platform en via Edifact in je
                    HIS als je je{' '}
                    <Link
                        openInNewTab={true}
                        to={`/employments/${selectedEmploymentId}/personalSettings`}
                        variant="link"
                    >
                        zorgmailnummer hebt doorgegeven
                    </Link>
                </Timeline.Item>
                <Timeline.Item>
                    Optioneel: Je stuurt het onderzoek door naar een Ksyos cardioloog voor advies over het vervolgbeleid
                    (via een consult)
                </Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
